module.exports = __webpack_public_path__ + "static/media/LP.0743ed43.png";